// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3jdoQ","inner":"styles_inner__3aYwa","right":"styles_right__MYqS_","close":"styles_close__rEHP-","footer":"styles_footer__EHobc"};